import {
  EVideoElementControllerBusEvent,
  IVideoElementControllerBusEventsMap,
} from 'components/videoElementController/VideoElementController.events';

export enum EVideoControllerCustomEvent {
  CLICK = 'videoElement.click',
  PLAYING = 'videoElement.playing',
  LOADING = 'videoElement.loading',
  PAUSE = 'videoElement.pause',
  VIDEO_PLAYBACK_STATE_CHANGE = 'videoElement.videoPlaybackStateChange',
  NATIVE_EVENT = 'videoElement.nativeEvent',
  UPDATE_PLAYER_RESOLUTION = 'videoElement.updatePlayerResolution',
  TIME_UPDATE = 'videoElement.timeUpdate',
}

export interface ICustomEventPayload {
  originalEvent: Event;
}

export type TCustomEventsMap = {
  [key in EVideoControllerCustomEvent]: CustomEvent<{}>;
} & {
  [EVideoControllerCustomEvent.NATIVE_EVENT]: CustomEvent<
    IVideoElementControllerBusEventsMap[EVideoElementControllerBusEvent.NATIVE_EVENT]
  >;
  [EVideoControllerCustomEvent.CLICK]: CustomEvent<ICustomEventPayload>;
  [EVideoControllerCustomEvent.UPDATE_PLAYER_RESOLUTION]: CustomEvent<{
    height: number;
    width: number;
  }>;
  [EVideoControllerCustomEvent.VIDEO_PLAYBACK_STATE_CHANGE]: CustomEvent<{
    prevState: string;
    nextState: string;
  }>;
  [EVideoControllerCustomEvent.PLAYING]: CustomEvent<{
    isAutoplay?: boolean;
  }>;
};
